import React from "react";
import MultiRowCarousel from "../../MultiRowsCarousel";
import leftArrow from "../../../../../assets/shapes_svg/ambition/left-arrow.svg";
import rightArrow from "../../../../../assets/shapes_svg/ambition/right-arrow.svg";
import "./index.css";
import { useNavigate } from "react-router-dom";

export const MarketingList = ({
  className,
  newName,
  setNewName,
  handleSave,
  efforts,
  link,
}) => {
  const navigate = useNavigate();
  const ButtonGroup = ({ onNext, onPrevious }) => {
    return (
      <div className="carousel-navigation">
        <img
          src={leftArrow}
          onClick={onPrevious}
          alt="Previous"
          className="marketing-nav-button"
        />
        <img
          src={rightArrow}
          onClick={onNext}
          alt="Next"
          className="marketing-nav-button"
        />
      </div>
    );
  };

  const handleItemClick = (item) => {
    navigate(link);
  };

  const renderItem = (item) => (
    <div
      className="marketing-action-item"
      onClick={() => handleItemClick(item)}
    >
      <h4>{item.name}</h4>
    </div>
  );

  return (
    <div className="marketing-action-container">
      <MultiRowCarousel
        containerClassName="marketing"
        items={efforts}
        rowsPerSlide={2}
        itemsPerRow={3}
        CustomButtonGroup={ButtonGroup}
        renderItem={renderItem}
        className={className}
        newName={newName}
        setNewName={setNewName}
        handleSave={handleSave}
      />
    </div>
  );
};
